<template>
  <div id="app">
    <loading ref="loading"></loading>

    <transition name="page" mode="out-in">
      <component v-if="layout" :is="layout"></component>
    </transition>
  </div>
</template>

<script>
import Loading from './Loading'

// Load layout components dynamically.
const requireContext = require.context('../layouts', false, /.*\.vue$/)

const layouts = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)]
  )
  .reduce((components, [name, component]) => {
    components[name] = component.default || component
    console.log(components)
    return components
  }, {})

export default {
  el: '#app',

  components: {
    Loading
  },

  metaInfo () {
    const { appName } = window.config

    return {
      title: appName,
      titleTemplate: `%s · ${appName}`
    }
  },

  data: () => ({
    layout: null,
    defaultLayout: 'app'
  }),

  mounted () {
    this.$loading = this.$refs.loading
    /* if('serviceWorker' in navigator) {
      navigator.serviceWorker
              .register('/sw.js')
              .then(function() { console.log("Service Worker Registered"); });
    } */
  },

  methods: {
    /**
     * Set the application layout.
     *
     * @param {String} layout
     */
    setLayout (layout) {
      console.log('layout: ',layout)
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout
      }

      this.layout = layouts[layout]
    }
  }
}
</script>
<style>
html:lang(en) .swal2-container{
  font-family: Roboto,sans-serif;
}

html:lang(km) .swal2-container{
  font-family: Chenla,sans-serif;
  line-height: 1.8;
}
.menu__content--select{max-height: 208px !important;}
.expansion-panel__header{padding:12px; }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/App.vue